module.exports = __webpack_public_path__ + "img/ai-chat-history-inactive-icon.25dc79be.svg";